import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private events: any[] | null = null;
  event: any;

  constructor(private http: HttpClient) {}

  getEvents(): Observable<any[]> {
    if (this.events) {
      return of(this.events);
    } else {
      return this.http.get<any[]>(`${environment.apiUrl}/v1/main/events?connId=${environment.connId}`).pipe(
        tap((data) => this.events = data)
      );
    }
  }

  getEvent(eventId: number, actionId: any, hashedId: string): Observable<any[]> {
    if (this.event && this.event?.data?.event.id === eventId && Number(this.event?.data?.action.id) === Number(actionId)) {
      return of(this.event);
    } else {
      return this.http.get<any[]>(`${environment.apiUrl}/conn/${environment.connId}/v1/events/${eventId}/${actionId}/${hashedId}`).pipe(
        tap((data) => this.event = data)
      );
    }
  }
}